import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { call, put, takeLatest } from "redux-saga/effects";
import { API_ENDPOINTS } from "../../../util/constants";
import {
  createHeadersWithAuth,
  createQueryString,
  requestPromise,
} from "../../../util/request";

export const actionTypes = {
  SetAgentsQueueInfo: "[Dashboard] SetAgentsQueueInfo Action",
  CallSummary: "[Dashboard] CallSummary Action",
  CallSummarySuccess: "[Dashboard] CallSummary Success Action",
  CallConnectivity: "[Dashboard] CallConnectivity Action",
  CallConnectivitySuccess: "[Dashboard] CallConnectivity Success Action",
  CallConnectivityCompare: "[Dashboard] CallConnectivityCompare Action",
  CallConnectivityCompareSuccess:
    "[Dashboard] CallConnectivityCompare Success Action",
  PerformanceCallPickupTime: "[Dashboard] PerformanceCallPickupTime Action",
  PerformanceCallPickupTimeSuccess:
    "[Dashboard] PerformanceCallPickupTime Success Action",
  PerformanceCallConnectivity: "[Dashboard] PerformanceCallConnectivity Action",
  PerformanceCallConnectivitySuccess:
    "[Dashboard] PerformanceCallConnectivity Success Action",
  SetFilters: "[Dashboard] SetFilters Action",
  LOADING: "[D]LOADING",
  LOADED: "[D]LOADED",
  AgentActivitySuccess: "AgentActivitySuccess",
};

const initialDashboardState = {
  callSummary: null,
  callConnectivity: {},
  callConnectivityCompare: {},
  performanceCallPickupTime: {},
  performanceCallConnectivity: {},
  filters: {
    solutions: {},
    plans: {},
    numbers: {},
    from_date: null,
    to_date: null,
    refresh: null,
  },
  loading_state: null,
  loading_states: {
    call_distribution: "",
    call_connectivity: "",
    agent_activity: "",
    agent_perf_callconnectivity: "",
    agent_perf_callpickuptime: "",
    call_insights: "",
    call_status_today: "",
    call_agent_status: "",
    live_call_logs: "",
    allocatedAgentsList: "",
    liveCallLogsWithFilters: "",
    total_agents: "",
    call_handling_today: "loaded",
    queue_wait_time_details: "loaded",
    disposition_lists: "",
    disposition_data: "",
    stickyAgent_lists: "",
    stickyAgent_data: "",
    phonebook_lists: "",
    phonebook_upload: "loaded",
    sound_lists: "",
    create_tts: "loaded",
    upload_sound: "loaded",
    update_userStatus: "loaded",
    iframe_logout: "loaded",
    hookapi_lists: "",
    template_lists: "",
    agentsettings_lists: "",
    agentsettings_dialog: "loaded",
    agent_activate: "loaded",
    queue_lists: '',
    queue_upsert:'loaded',
    queue_delete: 'loaded',
    agents_mapping:'loaded'
  },
  agentsMapByAgentId: {},
  agentsMapByQueueId: {},
  agentsQueue: [],
  agentsQueueIds: "",
  agentsEvents: {},
  agentsObjectsMapBy_cc_agent: {},
  agentsMapBy_cc_agent: {},
  log_levels: {
    "[AgentsActivity][WS]": 0,
    base: 0,
  },
};

export const LOADING_STATES = {
  call_insights: "call_insights",
  call_distribution: "call_distribution",
  call_connectivity: "call_connectivity",
  agent_activity: "agent_activity",
  agent_perf_callconnectivity: "agent_perf_callconnectivity",
  agent_perf_callpickuptime: "agent_perf_callpickuptime",
};

export const actions = {
  setAgentsQueueInfo: (payload) => ({
    type: actionTypes.SetAgentsQueueInfo,
    payload,
  }),
  callSummary: (payload) => ({ type: actionTypes.CallSummary, payload }),
  callSummarySuccess: (payload) => ({
    type: actionTypes.CallSummarySuccess,
    payload,
  }),

  callConnectivity: (payload) => ({
    type: actionTypes.CallConnectivity,
    payload,
  }),
  callConnectivitySuccess: (payload) => ({
    type: actionTypes.CallConnectivitySuccess,
    payload,
  }),
  callConnectivityCompare: (payload) => ({
    type: actionTypes.CallConnectivityCompare,
    payload,
  }),
  callConnectivityCompareSuccess: (payload) => ({
    type: actionTypes.CallConnectivityCompareSuccess,
    payload,
  }),

  performanceCallPickupTime: (payload) => ({
    type: actionTypes.PerformanceCallPickupTime,
    payload,
  }),
  performanceCallPickupTimeSuccess: (payload) => ({
    type: actionTypes.PerformanceCallPickupTimeSuccess,
    payload,
  }),

  performanceCallConnectivity: (payload) => ({
    type: actionTypes.PerformanceCallConnectivity,
    payload,
  }),
  performanceCallConnectivitySuccess: (payload) => ({
    type: actionTypes.PerformanceCallConnectivitySuccess,
    payload,
  }),
  setLoadingState: (payload) => {
    return { type: "loading_state", payload };
  },
  setLogLevel: (payload) => {
    return { type: "setLogLevel", payload };
  },
};

export const getKeyName = () => {
  return process.env.REACT_APP_VERSION + "-module-dashboard";
};

export const reducer = persistReducer(
  {
    storage,
    key: getKeyName(),
    whitelist: [
      "callSummary",
      "callPickupTime",
      "callConnectivity",
      "log_levels",
    ],
  },
  (state = initialDashboardState, action) => {
    switch (action.type) {
      case "[Auth] Logout Action": {
        return initialDashboardState;
      }
      case "loading_state": {
        if (action.payload.resource) {
          var resource = action.payload.resource;
          var loading_states = state.loading_states;
          loading_states[resource] = action.payload.loading_state;
          var ns = { ...state, loading_states: { ...loading_states } };
          return ns;
        }
        if (action.payload.loading_state)
          return { ...state, loading_state: action.payload.loading_state };
        break;
      }

      case "setLogLevel": {
        if (action.payload.log_level) {
          let log_level = action.payload.log_level;
          let log_levels = state.log_levels;
          log_levels[log_level] = action.payload.value;
          let ns = { ...state, log_levels: { ...log_levels } };
          return ns;
        }
        break;
      }

      case actionTypes.SetAgentsQueueInfo: {
        if (action.payload.category === "agentsEvents") {
          let newState = {
            ...state,
            agentsEvents: { ...action.payload.agentsEvents },
          };
          return newState;
        } else {
          let newState = {
            ...state,
            agentsMapByAgentId: { ...action.payload.agentsMapByAgentId },
            agentsMapByQueueId: { ...action.payload.agentsMapByQueueId },
            agentsQueueIds: action.payload.agentsQueueIds,
            agentsQueue: { ...action.payload.agentsQueue },
            queueMode: action.payload.queueMode,
            agentsObjectsMapBy_cc_agent: {
              ...action.payload.agentsObjectsMapBy_cc_agent,
            },
            agentsMapBy_cc_agent: { ...action.payload.agentsMapBy_cc_agent },
          };
          return newState;
        }
      }
      case actionTypes.CallSummarySuccess: {
        if (action.payload && action.payload.status === 200) {
          let loading_states = state.loading_states;
          let newState = {
            ...state,
            callSummary: action.payload.success,
            loading_states: { ...loading_states, call_distribution: "loaded" },
          };
          return newState;
        }
        return { ...state, callSummary: null };
      }

      case actionTypes.CallConnectivitySuccess: {
        if (action.payload && action.payload.status === 200) {
          let loading_states = state.loading_states;
          return {
            ...state,
            callConnectivity: action.payload.success,
            loading_states: { ...loading_states, call_connectivity: "loaded" },
          };
        }
        return { ...state, callConnectivity: null };
      }
      case actionTypes.CallConnectivityCompareSuccess: {
        if (action.payload && action.payload.status === 200) {
          return { ...state, callConnectivityCompare: action.payload.success };
        }
        let loading_states = state.loading_states;
        return {
          ...state,
          callConnectivityCompare: null,
          loading_states: { ...loading_states, call_connectivity: "loaded" },
        };
      }

      case actionTypes.PerformanceCallPickupTimeSuccess: {
        if (action.payload && action.payload.status === 200) {
          let loading_states = state.loading_states;
          return {
            ...state,
            performanceCallPickupTime: action.payload.success,
            loading_states: {
              ...loading_states,
              call_connectivity: "loaded",
              ...state.loading_states,
              agent_perf_callpickuptime: "loaded",
            },
          };
        }
        return { ...state, performanceCallPickupTime: null };
      }

      case actionTypes.PerformanceCallConnectivitySuccess: {
        if (action.payload && action.payload.status === 200) {
          let loading_states = state.loading_states;
          return {
            ...state,
            performanceCallConnectivity: action.payload.success,
            loading_states: {
              ...loading_states,
              agent_perf_callconnectivity: "loaded",
            },
          };
        }
        return { ...state, performanceCallConnectivity: null };
      }

      case actionTypes.AgentActivitySuccess: {
        if (action.payload && action.payload.status === 200) {
          return {
            ...state,
            loading_states: {
              ...state.loading_states,
              agent_activity: "loaded",
            },
          };
        }
        return { ...state };
      }

      case actionTypes.SetFilters: {
        return { ...state, filters: action.payload };
      }
      default:
        return state;
    }
  }
);

export function* postCallSummary(action) {
  yield put(actions.setLoadingState({ loading_state: "loading" }));
  yield put(
    actions.setLoadingState({
      resource: "call_distribution",
      loading_state: "loading",
    })
  );
  let requestURL = API_ENDPOINTS.getCallSummary;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";

  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.callSummarySuccess(response, options.method));
  } catch (error) {}
}

export function* postCallConnectivity(action) {
  yield put(
    actions.setLoadingState({
      resource: "call_connectivity",
      loading_state: "loading",
    })
  );
  let requestURL = API_ENDPOINTS.getCallConnectivity;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.callConnectivitySuccess(response, options.method));
  } catch (error) {}
}

export function* postCallConnectivityCompare(action) {
  yield put(
    actions.setLoadingState({
      resource: "call_connectivity",
      loading_state: "loading",
    })
  );
  let requestURL = API_ENDPOINTS.getCallConnectivity;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.callConnectivityCompareSuccess(response, options.method));
    yield put(
      actions.setLoadingState({
        resource: "call_connectivity",
        loading_state: "loaded",
      })
    );
  } catch (error) {}
}

export function* postPerformanceCallPickupTime(action) {
  yield put(
    actions.setLoadingState({
      resource: "agent_perf_callpickuptime",
      loading_state: "loading",
    })
  );
  let requestURL = API_ENDPOINTS.getPerformanceCallPickupTime;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    const response = yield call(requestPromise, requestURL, options);
    yield put(
      actions.setLoadingState({
        resource: "agent_perf_callpickuptime",
        loading_state: "loaded",
      })
    );
    yield put(
      actions.performanceCallPickupTimeSuccess(response, options.method)
    );
  } catch (error) {
    return;
  }
  yield put(
    actions.setLoadingState({
      resource: "agent_perf_callpickuptime",
      loading_state: "loaded",
    })
  );
}

export function* postPerformanceCallConnectivity(action) {
  yield put(
    actions.setLoadingState({
      resource: "agent_perf_callconnectivity",
      loading_state: "loading",
    })
  );
  let requestURL = API_ENDPOINTS.getPerformanceCallConnectivity;

  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    const response = yield call(requestPromise, requestURL, options);
    yield put(
      actions.performanceCallConnectivitySuccess(response, options.method)
    );
  } catch (error) {}

  yield put(actions.setLoadingState({ loading_state: "loaded" }));
  yield put(
    actions.setLoadingState({
      resource: "agent_perf_callconnectivity",
      loading_state: "loaded",
    })
  );
}

export function* saga() {
  yield takeLatest(actionTypes.CallSummary, postCallSummary);
  yield takeLatest(actionTypes.CallConnectivity, postCallConnectivity);
  yield takeLatest(
    actionTypes.CallConnectivityCompare,
    postCallConnectivityCompare
  );

  yield takeLatest(
    actionTypes.PerformanceCallPickupTime,
    postPerformanceCallPickupTime
  );
  yield takeLatest(
    actionTypes.PerformanceCallConnectivity,
    postPerformanceCallConnectivity
  );
}
